import { Link } from "react-router-dom";
import classes from "./index.module.scss";

export default function Card({ item }) {
  return item.custom_fields.link ? (
    <Link to={item.custom_fields.link[0]} className={classes.card}>
      <CardInner item={item} />
    </Link>
  ) : (
    <div className={classes.card}>
      <CardInner item={item} />
    </div>
  );
}

function CardInner({ item }) {
  return (
    <>
      <div className={classes.card__image}>
        <img
          src={item.img_url.full}
          alt={item.title.rendered}
          width={263}
          height={263}
        />
        {item.custom_fields.link ? <span></span> : null}
      </div>
      <h3 className={classes.card__title}>{item.title.rendered}</h3>
      <p className={classes.card__text}>
        {item.custom_fields.positionEmployee[0]}
      </p>
    </>
  );
}
